module.exports = __webpack_public_path__ + "static/media/Credence Barebone 3.28214f1c.jpg";